---
fr:
  power_plants:
    asset_class_types:
      all: TOUS
      bilateral/asset: Bilatéral
      hydro/asset: Hydroélectrique
      solar/asset: Solaire
      wind/asset: Éolien
    bell:
      link_ok: Le lien est OK
      no_link: Pas de lien
    bilateral_capacity_hint: Capacité installée pour cette centrale bilatérale
    capacity_hint: Édité en modifiant le composant producteur
    change_selection: Changer la sélection de la centrale électrique
    chart_load:
      categories:
      - Pas de production
      - B (25%)
      - M (25% - 75%)
      - H (> 75%)
      last_month: Dernier mois
      subtitle: "% du temps, heure par heure"
      this_month: Ce mois
      title: Charge
    chart_meteogram_title: Prévision de 48 heures
    commercial_details: Détails commerciaux
    commissioning_date_hint: Premier jour d'exploitation
    deviation: Écart
    edit_heading: Modifier les informations de la centrale électrique
    edit_notice: Contactez le personnel si des champs restreints doivent être modifiés
    effect_hint: Édité en modifiant le composant producteur
    elcert_count: Nombre d'elcerts
    environmental_flow_breakpoints: Débit environnemental
    errors:
      different_source: Doit être différent de la source fixée
      missing_attribute: Absent %{attribute}
      shadow_excludes_unscaled_contract: ne peut pas être activé tant qu'un contrat de tarif de rachat ou de couverture est associé, car ces contrats n'ont pas de part de propriété pour répartir la production partagée
      shadow_requires_canonical: doit correspondre au point de mesure d'une centrale non fantôme existante
    est_downtime_cost: Coût d'arrêt estimé
    est_production: Production estimée
    est_tech_downtime: Temps d'arrêt technique estimé
    export_xlsx: Exporter vers Excel
    financial_settlement: Réglementation financière
    generator: Générateur
    go_count: Nombre de GO
    intake: Prise d'eau
    intakes: Prises d'eau
    kpi_monthly: Performance mensuelle
    measure_theor_production: Aperçu - Production mesurée vs prévue
    measured_power: Puissance mesurée
    model_params:
      empty: Aucun paramètre de modèle disponible.
      nve_fallback_hint: Valeur NVE utilisée (saisissez une valeur pour la remplacer)
      production_min_runtime_hours_hint: Utilisé uniquement par deterministic_2step. Vide = valeur par défaut de l'API, 24 h. Doit tenir dans l'horizon d'optimisation (périodes × segments, 168 h par défaut), sinon le minimum n'est jamais engagé depuis l'arrêt.
      startup_override_placeholder: Saisissez les valeurs de production
    monthly_production: Vue d'ensemble mensuelle - production mesurée vs. prévue
    nve_info: Info NVE
    of_ytd_avg: de la moyenne YTD
    of_ytd_budget: du budget YTD
    penstock: Tuyau de refoulement
    power_curve: Courbe de puissance
    power_plant_age: Âge de la centrale électrique
    precipitation_field: Bassin versant
    price_prod_history: Historique des prix et de la production
    prod_bud_by_month: Production vs. budget par mois
    prod_by_month: Production par mois
    prod_sales_data: Données de production et de ventes
    reservoir: Réservoir
    rev_bud_by_month: Revenus vs. budget par mois
    rev_by_month: Revenus par mois
    river: Rivière
    runoff_avg: Débit moyen
    runoff_ytd: Débit YTD
    select_day: Sélectionnez le jour du mois
    select_month: Sélectionnez le mois
    shadow_source_hint: Copie l'ID du point de mesure de la centrale sélectionnée dans le champ ci-dessus
    shadow_source_label: Copier le point de mesure depuis une centrale
    solar_inverter_production: Production journalière normalisée des onduleurs [kWh/kWp]
    solar_kpi_epi: Energy Performance Index
    solar_kpi_pr: Performance Ratio
    solar_kpi_system_losses: Pertes systèmes
    spider_categories:
    - Heures à pleine charge (%)
    - Prix réalisé vs prix spot
    - Heures de fonctionnement total
    - Heures de fonctionnement de nuit
    - Production théorique vs production normale
    - Débit vs normal
    spot_price: Prix spot
    spot_revenue: Revenus spot
    starts_stops: Démarrages/arrêts
    substation: Sous-station
    supplier_add: Ajouter un fournisseur
    supplier_form_title: Fournisseurs
    theoretical_power: Puissance théorique
    tooltips:
      continuous_forecast_enabled: Resoumet la prévision de production day-ahead dès que de nouvelles données météorologiques de Meteomatics arrivent (centrales éoliennes/solaires).<br>Nécessite Forecast query et Day-ahead forecast.
      day_ahead_forecast_enabled: Soumet la prévision de production day-ahead (résolution 15 minutes) à Kaia Trade pour les centrales éoliennes/solaires toutes les heures de 07h20 à 11h20.<br>Nécessite Forecast query.
      forecast_query_enabled: Commutateur principal pour les soumissions sortantes vers Kaia Trade.<br>Lorsqu'activé, la tâche horaire de 07h20 à 11h20 (et l'interrogateur météo continu) envoient ce que les bascules ci-dessous activent&#58; plans de production, prévisions day-ahead et offres dépendantes du prix.<br>Désactiver arrête toutes les soumissions pour cette centrale.
      production_simulation_plan_enabled: Exécute la simulation de production localement toutes les heures de 07h10 à 11h10 et stocke le plan résultant.<br>Le plan est ensuite soumis à Kaia Trade par la tâche correspondante de 07h20 à 11h20 — cette soumission nécessite également Forecast query, un Kaia UUID et Shadow testing désactivé.<br>Les statuts accepté/rejeté retournés sont stockés sur chaque élément du plan.
      shadow_testing: Mode test shadow — interroge l'API de planification de production mais n'envoie rien à Trade (Kaia).<br>Utilisez ceci pour tester la planification de production sans affecter les soumissions au marché.
      use_price_dependent_bid: Soumet une courbe d'enchères dépendante du prix à Kaia Trade toutes les heures de 07h20 à 11h20, basée sur les prix du marché et l'économie de la centrale.<br>Nécessite Forecast query et un Market parameter avec les enchères activées sur cette centrale.
    tot_power_rev: Revenus totale de l'électricité
    total_hours: Heures totales
    total_revenue: Revenus totale
    total_sales: Ventes totales
    transformer: Transformateur
    turbine: Turbine
    turbine_types:
      bulb: Bulbe
      francis: Francis
      kaplan: Kaplan
      lawaczeck: Lawaczeck
      ossberger: Ossberger
      pelton: Pelton
      pump: Pompe
      turgo: Turgo
    unconfirmed: Nombres estimés / non confirmés
    water_icon:
      alert: Alerte sur le niveau d'eau
      normal: Niveau d'eau normal
      overflow: Débordement
      underflow: Déficit d'eau
      update: Pas de données récentes
    wind_kpi_eb_availability: Disponibilité énergétique
    wind_kpi_eb_losses: Pertes d'énergie
    wind_rose: Rose des vents
